import React, { Fragment } from 'react';

import { Desktop } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import { TFunction } from 'i18next';
import { TravelReportObject } from 'models/allReservations';
import { AllReservationsReportRequest, AllReservationsReportResponse } from 'models/allReservationsReport';

import AllReservationsReportForm from './AllReservationsReportFilter';
import { Container, Divider, Table, Title } from './styles';
import { Company } from 'models/company';
import { CostCenter } from 'models/costCenter';
import { BreakRulesReason } from 'services/travelBreakRulesReasonService';
import { Group } from 'models/group';
import { AdminUser } from 'models/adminUser';


export const RenderTravelReportViewAllReservations = (
  showViewInnerFilter: boolean,
  allReservationsList: TravelReportObject[],
  allCompaniesList: Company[],
  allUsersList: AdminUser[],
  allCostCenterList: CostCenter[],
  allBreakRuleReasonIdList: BreakRulesReason[],
  allUserGroupIdList: Group[],
  isLoading: boolean,
  isSubmit: boolean,
  isMobile: boolean,
  t: TFunction,
  fetchReportSummary: (filters: AllReservationsReportRequest, type: string) => Promise<any>,
  fetchUsersAndInvites: (companyId: string) => Promise<void>,
  handlePeriodText: (text?: string) => void,
  formattedPrice: (price?: number, currency?: string) => string,
  formatDate: (date: string) => string,
  formatStatus: (status: string) => string,
  report?: AllReservationsReportResponse,
  handleRowClick?: (id: any) => void,
  handleCloseDetails?: () => void,
  showDetails?: boolean,
  selectedTravelReport?: string,
  isShow?: boolean,
) => (
    <Container>
      {showViewInnerFilter && (
        <Fragment>
          <Desktop>
            <ScreenHeader title={t('allReservationsReport.report.title')} subtitle={t('allReservationsReport.report.subtitle')} />
          </Desktop>
          <AllReservationsReportForm
            loading={isLoading}
            companiesList={allCompaniesList}
            usersList={allUsersList}
            fetchUsersAndInvites={fetchUsersAndInvites}
            costCenterList={allCostCenterList}
            breakRuleReasonIdList={allBreakRuleReasonIdList}
            userGroupIdList={allUserGroupIdList}
            travelReportList={allReservationsList}
            fetchReportData={fetchReportSummary}
            onSetPeriodText={handlePeriodText}
            isSubmit={isSubmit}
          />
          <Divider />
          <br />
        </Fragment>
      )}

      {!isLoading && report && !isMobile && (
        <Container>
          <Title>{t('allReservationsReport.report.columns.title')}</Title>
          <Table>
            <table>
              <thead>
                <tr>
                  <Table.Item className="title">#</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.CompanyName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelArrangerFullName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.PassengersList')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.UserGroupName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.CostCenterCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.CostCenterName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelType')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.AirTravelType')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelStatus')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.CurrencyCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TotalFare')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VATIVAFare')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TotalOtherTaxes')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TotalTaxes')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TotalProvider')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TotalFees')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TotalPrice')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.PaymentAuthorizationNumber1')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.ValueAuthorizationNumber1')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.PaymentAuthorizationNumber2')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.ValueAuthorizationNumber2')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.last4digits')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.paymentStatus')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.paymentDate')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.PaymentFailureReason')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.paymentReference')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelReason')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.BreakingRulesJustify')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.BreakingRulesMessage')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.BreakingRules')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelJustify')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelRequiredApprovers')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelApprovers')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TravelCreatedDate')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.OriginCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.OriginName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.OriginDate')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.DestinationCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.DestinationName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.DestinationDate')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.ReturnDate')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.AirlineCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.AirlineName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.ConfirmationCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.TicketNumber')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.HotelName')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.HotelCheckin')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.HotelCheckout')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehiclePickup')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehicleDropoff')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehiclePickupLocationCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehiclePickupLocation')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehicleDropoffLocationCode')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehicleDropoffLocation')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehicleCompany')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.VehicleModel')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.LowestLogicalFare')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.privateFare')}</Table.Item>
                  <Table.Item className="title">{t('allReservationsReport.report.columns.privateRateCode')}</Table.Item>
                </tr>
              </thead>
              <tbody>
                {report?.travelReportList.map((booking) => (
                  <tr key={booking.travelItineraryId} onClick={() => handleRowClick(booking.id)}>
                    <Table.Item>{booking.travelItineraryId}</Table.Item>
                    <Table.Item>{booking.companyName}</Table.Item>
                    <Table.Item>{booking.travelArrangerFullName}</Table.Item>
                    <Table.Item>{booking.passengersList}</Table.Item>
                    <Table.Item>{booking.userGroupName}</Table.Item>
                    <Table.Item>{booking.costCenterCode}</Table.Item>
                    <Table.Item>{booking.costCenterName}</Table.Item>
                    <Table.Item>{booking.travelType}</Table.Item>
                    <Table.Item>{booking.airTravelType}</Table.Item>
                    <Table.Item>{booking.travelStatus}</Table.Item>
                    <Table.Item>{booking.currencyCode}</Table.Item>
                    <Table.Item>{booking.totalFare}</Table.Item>
                    <Table.Item>{booking.totalVAT}</Table.Item>
                    <Table.Item>{booking.totalOtherTaxes}</Table.Item>
                    <Table.Item>{booking.totalTaxes}</Table.Item>
                    <Table.Item>{booking.totalProvider}</Table.Item>
                    <Table.Item>{booking.totalFees}</Table.Item>
                    <Table.Item>{booking.totalPrice}</Table.Item>
                    <Table.Item>{booking.paymentAuthorizationNumber1}</Table.Item>
                    <Table.Item>{booking.valueAuthorizationNumber1}</Table.Item>
                    <Table.Item>{booking.paymentAuthorizationNumber2}</Table.Item>
                    <Table.Item>{booking.valueAuthorizationNumber2}</Table.Item>
                    <Table.Item>{booking.creditCardLast4Digits}</Table.Item>
                    <Table.Item>{booking.paymentStatus}</Table.Item>
                    <Table.Item>{booking.paymentDate}</Table.Item>
                    <Table.Item>{booking.paymentFailureReason}</Table.Item>
                    <Table.Item>{booking.paymentReference}</Table.Item>
                    <Table.Item>{booking.travelReason}</Table.Item>
                    <Table.Item>{booking.breakingRulesJustify}</Table.Item>
                    <Table.Item>{booking.breakingRulesMessage}</Table.Item>
                    <Table.Item>{booking.breakingRules}</Table.Item>
                    <Table.Item>{booking.travelJustify}</Table.Item>
                    <Table.Item>{booking.travelRequiredApprovers}</Table.Item>
                    <Table.Item>{booking.travelApprovers}</Table.Item>
                    <Table.Item>{booking.travelCreatedDate}</Table.Item>
                    <Table.Item>{booking.originCode}</Table.Item>
                    <Table.Item>{booking.originName}</Table.Item>
                    <Table.Item>{booking.originDate}</Table.Item>
                    <Table.Item>{booking.destinationCode}</Table.Item>
                    <Table.Item>{booking.destinationName}</Table.Item>
                    <Table.Item>{booking.destinationDate}</Table.Item>
                    <Table.Item>{booking.returnDate}</Table.Item>
                    <Table.Item>{booking.airlineCode}</Table.Item>
                    <Table.Item>{booking.airlineName}</Table.Item>
                    <Table.Item>{booking.confirmationCode}</Table.Item>
                    <Table.Item>{booking.ticketNumber}</Table.Item>
                    <Table.Item>{booking.hotelName}</Table.Item>
                    <Table.Item>{booking.hotelCheckin}</Table.Item>
                    <Table.Item>{booking.hotelCheckout}</Table.Item>
                    <Table.Item>{booking.vehiclePickup}</Table.Item>
                    <Table.Item>{booking.vehicleDropoff}</Table.Item>
                    <Table.Item>{booking.vehiclePickupLocationCode}</Table.Item>
                    <Table.Item>{booking.vehiclePickupLocation}</Table.Item>
                    <Table.Item>{booking.vehicleDropoffLocationCode}</Table.Item>
                    <Table.Item>{booking.vehicleDropoffLocation}</Table.Item>
                    <Table.Item>{booking.vehicleCompany}</Table.Item>
                    <Table.Item>{booking.vehicleModel}</Table.Item>
                    <Table.Item>{booking.lowestLogicalFare}</Table.Item>
                    <Table.Item>{booking.hasPrivateFare ? 'Si' : 'No' }</Table.Item>
                    <Table.Item>{booking.privateRateCode}</Table.Item>
                  </tr>
                ))}
              </tbody>
            </table>
          </Table>
        </Container>
      )}
    </Container>
  );
